import {addSubmitLoader, inputHasError, validateDisabledButton} from "./validation";
import {getCreatedHiddenInput} from "./paymentSubmitCommon";

export function unsubscribeLogic() {
  let alreadySubmitted;
  const unsCheckbox = document.getElementById("unsCheckbox");
  const formSubmit = document.getElementById("unsSubmit");
  const emailInput = document.getElementById("unsInput");
  // const unsCheckboxLabel = document.getElementById("unsCheckboxLabel");
  if (!unsCheckbox || !formSubmit || !emailInput) {
    return
  }

  unsCheckbox.addEventListener("change", () => {
    validateDisabledButton(formSubmit, inputsToCheck, true)
  })

  const inputsToCheck = [emailInput, unsCheckbox];

  const onBlurInput = (event) => {
    event.target.classList.remove("ui-input--focused");
    validateEmailInput();
    validateDisabledButton(formSubmit, inputsToCheck, true);
  }

  const onInputFocus = (event) => {
    if (!event.target.classList.contains("ui-input--touched")) {
      event.target.classList.add("ui-input--touched")
    }
    if (!event.target.classList.contains("ui-input--focused")) {
      event.target.classList.add("ui-input--focused")
    }
  }

  const onInputChange = () => {
    const shouldCheckSubmit = emailInput.value && unsCheckbox.checked;
    if (shouldCheckSubmit || emailInput.classList.contains("ui-input--error")) {
      validateEmailInput(formSubmit, inputsToCheck);
      validateDisabledButton(formSubmit, inputsToCheck, true);
    }
  }

  const onFormSubmit = (event) => {
    inputsToCheck.forEach(input => {
      if (!input) {
        return
      }
      onBlurInput({target: input})
    });
    const buttonDisabled = validateDisabledButton(formSubmit, inputsToCheck, true);
    if (buttonDisabled || alreadySubmitted) {
      formSubmit.disabled = true;
      event.preventDefault();
      return false
    }
    alreadySubmitted = true;
    addSubmitLoader(formSubmit);
    if (!window.grecaptcha || !document.pageInfo || !document.pageInfo.G_CAPTCHA_KEY) {
      return
    }
    event.preventDefault(); // prevent form submit, we will submit it after recaptcha executes
    window.grecaptcha.ready(() => {
      window.grecaptcha.execute(document.pageInfo.G_CAPTCHA_KEY, {action: 'submit'})
        .then((token) => {
          const input = getCreatedHiddenInput("g-token", token);
          const form = event.target.closest("form");
          form.appendChild(input);
          form.submit();
        });
    });
  }

  const validateEmailInput = (value = emailInput.value) => {
    if (inputHasError({value})) {
      emailInput.classList.add("ui-input--error");
      return true
    } else {
      emailInput.classList.remove("ui-input--error");
      return false
    }
  }
  emailInput.addEventListener("blur", onBlurInput);
  emailInput.addEventListener("focus", onInputFocus);
  emailInput.addEventListener("input", onInputChange);

  formSubmit.addEventListener("click", onFormSubmit);

  setTimeout(() => {
    if (emailInput && emailInput.value) {
      emailInput.classList.add("ui-input--touched")
    }
    validateDisabledButton(formSubmit, inputsToCheck, true); // first time
  }, 100)
}